import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { HomeSlider } from "../../component/HomeSlider";
import { TextVideoSection } from "../../container/TextVideoSection";
import { TitleHeading } from "../../molecules/TitleHeading";
import { ArrowListing } from "../../molecules/ArrowListing";
import Slider1 from "./Slider1";
import Slider2 from "./Slider2";
import { DetailBox } from "molecules/DetailBox";
import { ArrowButton } from "molecules/ArrowButton";
import { SmallHadding } from "molecules/SmallHeadding";
import { SectionBorder } from "molecules/SectionBorder";
import { MainSlider } from "component/MainSlider";
import { MidTitle } from "molecules/MidTitle";
import PeopleSlider from "pages/OurPeople/PeopleSlider";
import { ButtonSlider } from "component/ButtonSlider";
import Divider from "molecules/SimpleBorder/Divider";
import TruncatedText from "component/TruncatedText/TruncatedText";
import { useNavigate } from "react-router-dom";
import { fetchCareers, fetchCareerImages } from "../../api";

const Home = () => {
  const navigation = useNavigate();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [careersData, setCareersData] = useState(null);
  const [careerImages, setCareerImages] = useState([]);
  const [loadingCareers, setLoadingCareers] = useState(false);
  const { data, loading, error } = useSelector((state) => state.dashboard);

  const {
    data: blogsData,
    loading: loadingBlogs,
    error: errorBlogs,
  } = useSelector((state) => state.blogs);

  //  console.log("homeslider",data,loading,error)

  const homeData = data;

  //  console.log(blogsData,"1212")

  const { homeSlider } = useSelector(
    (state) => state.dashboard
  );

  useEffect(() => {
    console.log("homeSlider", data);
  }, [homeSlider]);

  // Fetch careers data
  useEffect(() => {
    const loadCareersData = async () => {
      setLoadingCareers(true);
      try {
        const careers = await fetchCareers();
        if (careers && careers.length > 0) {
          setCareersData(careers[0]); // Get first career entry
        }
      } catch (error) {
        console.error("Error fetching careers:", error);
      } finally {
        setLoadingCareers(false);
      }
    };

    loadCareersData();
  }, []);

  // Fetch career images
  useEffect(() => {
    const loadCareerImages = async () => {
      try {
        const images = await fetchCareerImages();
        if (images && Array.isArray(images)) {
          setCareerImages(images);
        }
      } catch (error) {
        console.error("Error fetching career images:", error);
      }
    };

    loadCareerImages();
  }, []);

  const listindata = [
    {
      listtitle: homeData?.milestone_history_pointer_1_title,
      listdetail: homeData?.milestone_history_pointer_1_text,
    },
    {
      listtitle: homeData?.milestone_history_pointer_2_title,
      listdetail: homeData?.milestone_history_pointer_2_text,
    },
    {
      listtitle: homeData?.milestone_history_pointer_3_title,
      listdetail: homeData?.milestone_history_pointer_3_text,
    },
    {
      listtitle: homeData?.milestone_history_pointer_4_title,
      listdetail: homeData?.milestone_history_pointer_4_text,
    },
  ];
  const listindata2 = [
    {
      listtitle: careersData?.subsection_title1 || "Life At Quantum",
      listdetail:
        careersData?.subsection_description1 ||
        "Quantum is driven by its Vision statement: \"To elevate the professional standards of the India\"",
      listlink: "www.google.com",
    },
    {
      listtitle: careersData?.subsection_title2 || "Our Community Impact",
      listdetail:
        careersData?.subsection_description2 ||
        "Quantum is driven by its Vision statement: \"To elevate the professional standards of the India\"",
      listlink: "www.google.com",
    },
  ];

  return (
    <div className="backgroundThm ">
      <section className="sliderSection  ">
        <HomeSlider data={data} />
      </section>

      <section
        className="video-section mobileContainer  "
        style={{ backgroundColor: "rgb(245, 244, 241)" }}
      >
        {/* <div className="container1 " style={{}}    >
       
      </div> */}

        <TextVideoSection data={data} />

        {/* </div> */}
      </section>

      {/* <div className=" mileContainer "> */}
      <section
        className="map_sction section-padding1  px-0 pb-0 pt-0 "
        style={{ backgroundColor: "rgb(245, 244, 241)" }}
      >
        <div className="mileContainer">
          <div className="container pl-0 pr-0 milstoneTopPadding">
            <SectionBorder />
          </div>

          <div className="container px-0  mb-4 ">
            <div
              className="grid   "
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div className="col-lg-5 col-md-7 col-sm-12 milstoneHistoeryWidth p-0">
                <div className="section-title mb-5 ">
                  <TitleHeading
                    title={
                      homeData?.milestone_history_title || "Milestone History"
                    }
                    className=""
                  />
                </div>
                <ArrowListing
                  data={listindata}
                  className="map-label-listing text-capitalize text-bold"
                  color="#C82027"
                />
              </div>
              <div className="lg:col-5 md:col-7 sm:col-12 md:pl-6 pr-0 flex justify-content-end ">
                <img
                  // src={homeData?.milestone_history_map ||"media/HomePageMap.png"}
                  src={`${
                    homeData?.milestone_history_map
                      ? "" + homeData?.milestone_history_map
                      : "media/HomePageMap.png"
                  }`}
                  // src="media/HomePageMap.png"
                  alt={"map-image"}
                  className="img-fluid mt-2 map-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* </div> */}

      <section
        className="bg-white client_section section-padding1"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <Slider1 data={data} />
      </section>
     

      <section className="section-padding1 pt-0 bg-white">
        <div className="container  pl-0 pr-0">
          <div className="grid  align-items-center ">
            <div
              className="lg:col-5 md:col-12 sm:col-12 pl-0 d-flex flex-column  pt-3"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <TitleHeading
                title={
                  data?.completed_projects_title || "Our Completed Projects"
                }
                className="mb-2"
              />
              <DetailBox
                details={
                  data?.completed_projects_subtitle ||
                  "Quantum is driven by its Vision statement: “To elevate the..."
                }
                className="my-5 "
              />
              <ArrowButton
                width="170"
                buttonText={
                  data?.completed_projects_hyperlink_text || "View all"
                }
                bgColor="#CDC08B"
                textColor="#000000"
                url={data?.completed_projects_hyperlink_link}
              />
            </div>
            <div
              className="lg:col-7 md:col-12 sm:col-12 "
              data-aos="fade-down"
              data-aos-duration="1000"
            >
              <div className="grid lg:pl-8   mobileCompletedProjects ">
                <div className="lg:col-4 md:col-3 sm:col-6 mb-3 ">
                  <a
                    href="/"
                    className="no-underline text-center text-black-alpha-90"
                  >
                    <div className="listing-imgbox m-auto">
                      <img
                        src={
                          data?.completed_projects_image_1 ||
                          "media/project/Residential.png"
                        }
                        alt=""
                        srcset=""
                        style={{ width: "165px", marginTop: "50px" }}
                        className=""
                      />
                    </div>

                    <h4 className="text-center my-1 fontAva ">
                      {data?.completed_projects_image_title_1 || "Residential"}
                    </h4>
                  </a>
                </div>
                <div className="lg:col-4 md:col-3 sm:col-6 mb-4 ">
                  <a
                    href="/"
                    className="no-underline text-center text-black-alpha-90"
                  >
                    <div className="listing-imgbox m-auto">
                      <img
                        src={
                          data?.completed_projects_image_2 ||
                          "media/project/Commercial.png"
                        }
                        alt=""
                        srcset=""
                        style={{ width: "165px", marginTop: "50px" }}
                        className=""
                      />
                    </div>

                    <h4 className="text-center my-1 fontAva">
                      {data?.completed_projects_image_title_2 || "Commercial"}
                    </h4>
                  </a>
                </div>
                <div className="lg:col-4 md:col-3 sm:col-6 mb-4">
                  <a
                    href="/"
                    className="no-underline text-center text-black-alpha-90"
                  >
                    <div className="listing-imgbox m-auto">
                      <img
                        src={
                          data?.completed_projects_image_3 ||
                          "media/project/Industrial.png"
                        }
                        alt=""
                        style={{ width: "165px", marginTop: "50px" }}
                        className=""
                      />
                    </div>

                    <h4 className="text-center my-1 fontAva">
                      {data?.completed_projects_image_title_3 ||
                        " Industrial & Logistics"}
                    </h4>
                  </a>
                </div>
                <div
                  className="lg:col-4 md:col-3 sm:col-6"
                  style={{ marginTop: "-50px" }}
                >
                  <a
                    href="/"
                    className="no-underline text-center text-black-alpha-90"
                  >
                    <div className="listing-imgbox m-auto">
                      <img
                        src={
                          data?.completed_projects_image_4 ||
                          "media/project/Retail.png"
                        }
                        alt=""
                        style={{ width: "165px", marginTop: "50px" }}
                        className=""
                      />
                    </div>

                    <h4 className="text-center my-1 fontAva">
                      {data?.completed_projects_image_title_4 || "Retail"}
                    </h4>
                  </a>
                </div>
                <div
                  className="lg:col-4 md:col-3 sm:col-6"
                  style={{ marginTop: "-50px" }}
                >
                  <a
                    href="/"
                    className="no-underline text-center text-black-alpha-90"
                  >
                    <div className="listing-imgbox m-auto">
                      <img
                        src={
                          data?.completed_projects_image_5 ||
                          "media/project/Hospitality.png"
                        }
                        alt=""
                        style={{ width: "165px", marginTop: "50px" }}
                        className=""
                      />
                    </div>

                    <h4 className="text-center my-1 fontAva">
                      {data?.completed_projects_image_title_5 || "Hospitality"}
                    </h4>
                  </a>
                </div>
                <div
                  className="lg:col-4 md:col-3 sm:col-6 "
                  style={{ marginTop: "-50px" }}
                >
                  <a
                    href="/"
                    className="no-underline text-center text-black-alpha-90"
                  >
                    <div className="listing-imgbox m-auto">
                      <img
                        src={
                          data?.completed_projects_image_6 ||
                          "media/project/Townships.png"
                        }
                        alt=""
                        style={{
                          width: "165px",
                          marginTop: "50px",
                          marginLeft: "auto",
                        }}
                        className=""
                      />
                    </div>

                    <h4 className="text-center my-1 fontAva">
                      {data?.completed_projects_image_title_6 || "Townships"}
                    </h4>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="section-padding1"
        data-aos="fade-up"
        style={{ backgroundColor: "rgb(245, 244, 241)" }}
      >
        <div className="container pl-0 pr-0">
          <div className="grid section-title">
            <div className="lg:col-4 md:col-3 sm:col-12 pl-0">
              <TitleHeading 
                title={careersData?.title || "Careers"} 
                className="mt-0 mb-3" 
              />
            </div>
            <div className="lg:col-5 md:col-5 sm:col-12 mt-2">
              <DetailBox
                details={careersData?.description || "Quantum is driven by its um is driven by its V Vision statement: \"To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience\" Quantum imb  the professional standards of the Indian realty sector"}
                className="  mt-0 "
              />
            </div>
            <div className="lg:col-3 md:col-4 sm:col-12 mt-3 pr-0">
              <div className="flex justify-content-end">
                <ArrowButton
                  width="170"
                  buttonText={careersData?.hyperlink_text || "Our People"}
                  bgColor="#CDC08B"
                  textColor="#000000"
                  url={careersData?.hyperlink_url || "http://16.170.18.3/careers"}
                  className="ml-0"
                />
              </div>
            </div>
          </div>
          <div className="grid ">
            <div
              className="lg:col-5 md:col-6 sm:col-12 lg:col-offset-4"
              data-aos="fade-up"
            >
              {/* <SmallHadding text="HEAR FROM THEM" className="text-xl" /> */}
              <p
                className="uppercase"
                style={{
                  fontSize: "18px",
                  fontWeight: "500",
                  // marginTop: "15px",
                }}
              >
                {careersData?.header_text || "HEAR FROM THEM"}
              </p>
              {/* <SmallHadding text="Hear From Them" className="text-2xl" /> */}
              {/* <h2 style={{textDecoration:'uppercase'}}>
                Hear from them
              </h2> */}

              <ArrowListing
                data={listindata2}
                textColor={"#000"}
                font="Avenir"
                fontSize="23px"
              />
              <ArrowButton
                width="170"
                buttonText={careersData?.view_employment_text || "View Employment Opportunities"}
                bgColor="#CDC08B"
                textColor="#000000"
                url={careersData?.view_employment_link || "/"}
              />
            </div>
          </div>

          {/* <div className="container pl-0 pr-0  grid mt-4   ">
            <ButtonSlider data={careerImages} />
          </div> */}
        </div>
      </section>
    </div>
  );
};

export default Home;
